// @ts-nocheck
export const localeCodes =  [
  "en",
  "es"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_4d7c9203",
      load: () => import("#nuxt-i18n/4d7c9203" /* webpackChunkName: "locale_en_46json_4d7c9203" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_f57f828b",
      load: () => import("#nuxt-i18n/f57f828b" /* webpackChunkName: "locale_es_46json_f57f828b" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: undefined
  },
  {
    code: "es",
    iso: "es-MX",
    name: "Español",
    language: undefined
  }
]
/** client **/

/** client-end **/